module.exports = __webpack_public_path__ + "img/bn.f5c0c8e7.svg";